<template>
  <div>
    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">PF Settings<span>
        <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / PF ARR Declarations</span>
    </h4>
    <div class="ibox">
      <div class="  clearfix row no-margin ibox-content mt-3">
        <div class="col-md-12 fixed-section-one mb-4">
          <div class="clearfix approval-container row">
            <div class="col-4 approve-level-label">
              <div class="approve-level-title px-0 text-left">
                PF ARR Declarations
              </div>
              <div class="approve-level-description">
                ARR percentages are used to calculate the profit for the months after the most recent closed audit
                period for members who are leaving the Provident Fund (leaving the company in case of BBPLC) ARR
                percentages are normally declared after the audit of a period is formally closed. However, these are
                declared such that there is a date of declaration and an effective date. The date of declaration is the
                date on which this ARR was signed-off on by the PF Board of Trustees and the effective date indicates
                that any member leaving on or after that date will be receiving profit based on that declared rate.
              </div>
            </div>
            <div class="col-8 approve-level-content">
              <div class="clearfix px-0 border-bottom">
                <div class="clearfix">
                  <div class="row py-2 mb-2 border-bottom">
                    <div class="col-sm-5 px-3 company-form-box-title">PF ARR Declarations</div>

                  </div>

                  <div class="clearfix row py-2 mb-2">

                    <div class="col-12 px-3 mb-3">
                      <!-- Top Alert -->
                      <b-alert v-if="active_declaration.is_available == 0" variant="warning" show
                        class="py-2 px-3 small font-italic border border-warning">
                        The system currently does not have any declared Provident Fund ARR.
                        Any member leaving the Provident Fund currently will be allocated with profit
                        calculated at a rate of 0% for the months after latest audited period.
                      </b-alert>

                      <!-- Two Column Table -->
                      <b-card class="mt-3">
                        <b-row class="border-bottom py-1 font-weight-bold">
                          <b-col sm="6">
                            <span>Active ARR for Current Date:</span>
                            <span class="ml-2 text-dark">{{ active_declaration.active_arr }}%</span>
                          </b-col>
                          <b-col sm="6">
                            <span>Latest Declared ARR:</span>
                            <span class="ml-2 text-dark">{{ active_declaration.latest_arr }}%</span>
                          </b-col>
                        </b-row>

                        <b-row class="py-1">
                          <b-col sm="6">
                            <span>Effective From:</span>
                            <span class="ml-2 text-dark">{{ active_declaration.active_effective_from || '-' }}</span>
                          </b-col>
                          <b-col sm="6">
                            <span>Effective From:</span>
                            <span class="ml-2 text-dark">{{ active_declaration.latest_effective_from || '-' }}</span>
                          </b-col>
                        </b-row>
                      </b-card>
                    </div>
                    <div class="col-sm-4">
                      <div class="custom-search float-right w-100">
                        <b-input-group class="mb-0">
                          <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                          </b-input-group-prepend>
                          <b-form-input type="search" placeholder="Search.." v-model="search"
                            @input="resetPagination()"></b-form-input>
                        </b-input-group>
                      </div>
                    </div>
                    <div class="col-sm-3 text-right pr-0">
                      <!-- <b-button id="show-btn" class="mr-3" @click="addNew()"> Declare ARR</b-button> -->
                      <!-- Rejwan: 09-09-2025 ACL -->
                      <b-button id="show-btn" class="mr-3" @click="addNew()" v-if="audit_id > 0"> Declare ARR</b-button>
                      <!-- Rejwan: 09-09-2025 ACL -->
                    </div>
                  </div>

                  <table class="table dataTable">
                    <thead>
                      <tr class="table-head">
                        <template v-for="column in columns">
                          <th v-if="column.sort" :key="column.name" @click="sortBy(column.name)"
                            :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;">
                            <span>{{ column.label }}</span>
                          </th>
                          <th v-else :key="column.name"><span>{{ column.label }}</span></th>
                        </template>
                      </tr>
                    </thead>

                    <tbody>
                      <tr class="hover-bg table-row mx-2" v-for="item in paginatedData" :key="item.id">
                        <td>{{ item.date_of_declaration }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.arr }}</td>
                        <td>{{ item.effective_date }}</td>
                        <td>{{ item.updated_at }}</td>
                        <!-- <td class="text-right position-relative"> --> <!-- Rejwan: 09-09-2025 ACL -->
                        <td class="text-right position-relative" v-if="$acl['company/savepfsettings'] == 2">
                          <!-- Rejwan: 09-09-2025 ACL -->
                          <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                            style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <b-icon icon="three-dots-vertical"></b-icon>
                          </a>
                          <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                            <b-button-group>
                              <b-button variant="outline-secondary" @click="editData(item.id)">
                                <b-icon icon="pencil"></b-icon> Edit
                              </b-button>
                              <b-button variant="outline-danger" @click="deleteData(item.id)">
                                <b-icon icon="trash"></b-icon> Delete
                              </b-button>
                            </b-button-group>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="paginatedData.length > 0">
                        <td :colspan="columns.length">
                          <div class="row p-2 float-right">
                            <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages"
                              prev-text="Previous" next-text="Next" base-url="#" first-number
                              last-number></b-pagination-nav>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="paginatedData.length === 0">
                        <td :colspan="columns.length">{{ blankmsg }}</td>
                      </tr>
                    </tbody>
                  </table>

                  <b-modal id="bv-modal-add-or-update-arr-declaration" size="lg" hide-footer :title="modal_title">

                    <!-- Top Alert -->
                    <b-alert v-if="disable_edit == 1" variant="danger" show
                      class="py-2 px-3 small font-italic border border-danger">
                      This ARR Declaration cannot be edited as it has been used in some PF Profit Calculations.
                    </b-alert>

                    <!-- Top Alert -->
                    <b-alert variant="info" show class="py-2 px-3 small font-italic border border-warning">
                      Profit will be calculated for months after the latest Audited period for any member leaving the
                      Provident Fund
                      as per the declared ARR percentage if their separation date falls on or after effective date.
                    </b-alert>

                    <b-form @submit.stop.prevent="onSubmit">
                      <b-form-group label="Date of Declaration [YYYY-MM-DD]" label-for="date_of_declaration"
                        class="required-field">
                        <b-input-group class="mb-3">
                          <b-form-input id="date_of_declaration" name="date_of_declaration"
                            data-vv-as="Date of Declaration" v-model="fdata.date_of_declaration"
                            placeholder="YYYY-MM-DD" v-validate="'required|date_format:yyyy-MM-dd'"
                            :class="{ 'is-invalid': veeErrors.has('date_of_declaration') }"
                            :disabled="disable_edit == 1" />
                          <b-input-group-append>
                            <b-form-datepicker v-model="fdata.date_of_declaration" button-only right
                              :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                              :disabled="disable_edit == 1" />
                          </b-input-group-append>
                          <b-form-invalid-feedback v-if="veeErrors.has('date_of_declaration')" class="pl-2">
                            {{ veeErrors.first('date_of_declaration') }}
                          </b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>

                      <b-form-group label="Effective Date [YYYY-MM-DD]" label-for="effective_date"
                        class="required-field">
                        <b-input-group class="mb-3">
                          <b-form-input id="effective_date" name="effective_date" data-vv-as="Effective Date"
                            v-model="fdata.effective_date" placeholder="YYYY-MM-DD"
                            v-validate="enable_migration_date_lock ? 'required|date_format:yyyy-MM-dd|after_effective_date' : 'required|date_format:yyyy-MM-dd'"
                            :class="{ 'is-invalid': veeErrors.has('effective_date') }" :disabled="disable_edit == 1" />
                          <b-input-group-append>
                            <b-form-datepicker v-model="fdata.effective_date" button-only right
                              :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                              :min="enable_migration_date_lock ? effective_date_min : null"
                              :disabled="disable_edit == 1" />
                          </b-input-group-append>
                          <b-form-invalid-feedback v-if="veeErrors.has('effective_date')" class="pl-2">
                            {{ veeErrors.first('effective_date') }}
                          </b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>

                      <b-form-group id="arr-group" label="ARR" label-for="arr" class="required-field">
                        <b-form-input id="arr" name="arr" v-model="fdata.arr"
                          v-validate="'required|decimal:2|min_value:0.001|max_value:100'" :state="validateState('arr')"
                          aria-describedby="arr-feedback" data-vv-as="ARR" :disabled="disable_edit == 1"></b-form-input>
                        <b-form-invalid-feedback id="arr-feedback">{{ veeErrors.first('arr')
                          }}</b-form-invalid-feedback>
                      </b-form-group>

                      <b-form-group id="description-group" label="Description" label-for="description">
                        <b-form-textarea id="description" name="description" v-model="fdata.description" rows="3"
                          v-validate="'min:3'" :state="validateState('description')"
                          aria-describedby="description-feedback" data-vv-as="Description"
                          :disabled="disable_edit == 1"></b-form-textarea>
                        <b-form-invalid-feedback id="description-feedback">{{ veeErrors.first('description')
                          }}</b-form-invalid-feedback>
                      </b-form-group>

                      <b-form-group id="attachment-group" label="Attachment" label-for="attachment">
                        <b-form-file id="attachment" name="attachment" v-model="fdata.attachment"
                          :state="validateState('attachment')" :accept="accept" :multiple="false"
                          aria-describedby="attachment-feedback" data-vv-as="Attachment"
                          @change="checkFileType($event, 'attachment', ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'])"
                          :disabled="disable_edit == 1">
                        </b-form-file>
                        <b-form-invalid-feedback id="attachment-feedback">{{ veeErrors.first('attachment')
                          }}</b-form-invalid-feedback>
                        <!-- Add a download link for the attachment if it exists -->
                        <div v-if="fdata.attachment">
                          <a href="#" @click="downloadFileContent(fdata.attachment, 1)"
                            class="mt-2 d-inline-block">Download
                            Attachment</a>
                        </div>
                      </b-form-group>


                      <div class="full-width text-center mt-4" v-if="disable_edit == 0">
                        <b-button type="submit" variant="primary">Submit</b-button>
                      </div>
                    </b-form>
                  </b-modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment';
export default {
  mounted() {
    this.$validator.extend('date_format', {
      getMessage: field => `${field} must be in YYYY-MM-DD format`,
      validate: value => {
        return /^\d{4}-\d{2}-\d{2}$/.test(value);
      }
    });
    this.$validator.extend('after_effective_date', {
      getMessage: field => `${field} must be on or after the minimum effective date`,
      validate: value => {
        if (!this.enable_migration_date_lock || !this.effective_date_min) return true;
        return moment(value, 'YYYY-MM-DD').isSameOrAfter(moment(this.effective_date_min, 'YYYY-MM-DD'));
      },
      paramNames: []
    });
  },
  props: ['arr_id', 'audit_id'],
  data() {
    let sortOrders = {};
    let columns = [
      { label: 'Declaration Date', name: 'date_of_declaration', sort: true, type: 'date' },
      { label: 'Description', name: 'description', sort: true },
      { label: 'ARR', name: 'arr', sort: true, type: 'number' },
      { label: 'Effective Date', name: 'effective_date', sort: true, type: 'date' },
      { label: 'Last Updated', name: 'updated_at', sort: true, type: 'date' },
      { label: 'Actions', name: 'actions', sort: false }
    ];

    columns.forEach((column) => { sortOrders[column.name] = 1; });

    return {
      blankmsg: 'Fetching data...',
      datalist: [],
      showoverlay: false,
      fdata: {
        id: null,
        date_of_declaration: '',
        effective_date: '',
        arr: '',
        description: '',
        attachment: null
      },
      search: '',
      columns,
      sortKey: 'date_of_declaration',
      sortOrders,
      length: 10,
      pagination: {
        currentPage: 1,
        total: 0,
        pages: 1
      },
      modal_title: 'Add New ARR Declaration',
      accept: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,image/png',
      active_declaration: {
        is_available: 0,
        active_arr: 0,
        latest_arr: 0,
        active_effective_from: '',
        latest_effective_from: ''
      },
      enable_migration_date_lock: 0,
      migration_date: null,
      effective_date_min: null,
      disable_edit: 0
    }
  },

  methods: {
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    resetForm() {
      this.fdata = {
        id: null,
        date_of_declaration: '',
        effective_date: '',
        arr: '',
        description: '',
        attachment: null
      };
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },

    addNew() {
      this.getMigrationLockSettings();
      this.resetForm();
      this.modal_title = 'Add New ARR Declaration';
      this.$bvModal.show('bv-modal-add-or-update-arr-declaration');
    },

    getData() {
      if (!this.checkNet()) return;
      this.showoverlay = true;
      this.blankmsg = 'Fetching data...';

      axios.get(this.$api_url + '/pf/get-arr-declarations', {
        params: {
          audit_id: this.audit_id
        }
      })
        .then(response => {
          this.datalist = response.data.data.all || [];

          let active_data = response.data.data.active;

          if (active_data.is_available == 1) {
            this.active_declaration = {
              is_available: 1,
              active_arr: active_data.active_arr,
              latest_arr: active_data.latest_arr,
              active_effective_from: active_data.active_effective_from,
              latest_effective_from: active_data.latest_effective_from
            }
          }

          this.blankmsg = this.datalist.length === 0 ? 'Nothing found.' : '';
          this.updatePagination();
          this.showoverlay = false;
        })
        .catch(error => {
          this.showoverlay = false;
          this.serverError(error);
          this.blankmsg = 'Error fetching data.';
        });
    },
    editData(id) {
      if (!this.checkNet()) return;

      this.getMigrationLockSettings();

      this.hasArrDeclarationBeenUsed(id).then(() => {
        this.showoverlay = true;
        this.modal_title = 'Update ARR Declaration';

        let formData = new FormData();
        formData.append('id', id);
        this.fdata.id = id;

        axios.post(this.$api_url + '/pf/get-arr-declaration', formData)
          .then(response => {
            this.fdata = {
              ...response.data.data,
              id,
              // attachment: null
            };
            this.$bvModal.show('bv-modal-add-or-update-arr-declaration');
            this.showoverlay = false;
          })
          .catch(error => {
            this.showoverlay = false;
            this.serverError(error);
          });
      });
    },
    deleteData(id) {
      if (!this.checkNet()) return;

      this.hasArrDeclarationBeenUsed(id).then(() => {
        if (this.disable_edit == 1) {
          this.$bvToast.toast('The ARR Declaration cannot be deleted as it has been used in some PF Profit Calculations.', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
          return;
        }

        let formData = new FormData();
        formData.append('id', id);

        this.$bvModal.msgBoxConfirm('Please confirm that you want to delete.', {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if (value) {
              this.showoverlay = true;
              axios.post(this.$api_url + '/pf/delete-arr-declaration', formData)
                .then(() => {
                  this.getData();
                  this.$bvToast.toast('Deleted successfully!', {
                    title: 'Success',
                    variant: 'success',
                    solid: true
                  });
                })
                .catch(error => {
                  this.showoverlay = false;
                  this.serverError(error);
                });
            }
          });
      });
    },
    onSubmit(e) {
      e.preventDefault();

      if (!this.checkNet()) return;

      this.$validator.validateAll().then(result => {
        if (!result) return;

        this.showoverlay = true;
        let formData = new FormData();

        Object.entries(this.fdata).forEach(([key, value]) => {
          if (key === 'attachment' && value instanceof File) {
            formData.append('attachment', value);
          } else if (value !== null && value !== undefined) {
            formData.append(key, value);
          }



        });

        if (this.audit_id > 0) {
          formData.append('audit_id', this.audit_id);
          formData.append('status', 0);
        }

        let url;
        if (this.fdata.id > 0) {
          url = this.$api_url + '/pf/update-arr-declaration';
        } else {
          url = this.$api_url + '/pf/save-arr-declaration';
        }

        axios.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
          .then(() => {
            this.getData();
            this.$bvToast.toast('Saved successfully!', {
              title: 'Success',
              variant: 'success',
              solid: true
            });
            this.$bvModal.hide('bv-modal-add-or-update-arr-declaration');
            this.resetForm();
            this.showoverlay = false;
          })
          .catch(error => {
            this.showoverlay = false;
            this.serverError(error);
          });
      });
    },

    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrders[key] = this.sortOrders[key] * -1;
      }
      this.sortKey = key;
    },

    resetPagination() {
      this.pagination.currentPage = 1;
      this.updatePagination();
    },

    updatePagination() {
      this.pagination.total = this.filteredData.length;
      this.pagination.pages = Math.ceil(this.pagination.total / this.length);
      this.pagination.from = ((this.pagination.currentPage - 1) * this.length) + 1;
      this.pagination.to = Math.min(this.pagination.from + this.length - 1, this.pagination.total);
    },

    paginate(data, perPage, currentPage) {
      const start = (currentPage - 1) * perPage;
      return data.slice(start, start + perPage);
    },

    checkNet() {
      if (!navigator.onLine) {
        this.$bvToast.toast('No internet connection', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
        return false;
      }
      return true;
    },

    serverError(error) {
      this.$bvToast.toast(error.response?.data?.message || 'An error occurred', {
        title: 'Error',
        variant: 'danger',
        solid: true
      });
    },
    getIndex(array, key, value) {
      return array.findIndex(i => i[key] === value);
    },
    getMigrationLockSettings() {
      axios
        .get(this.$api_url + '/pf/get-migration-date-settings')
        .then(response => {
          let res = response.data || {};
          if (res.enable_migration_date_lock == 1) {
            this.enable_migration_date_lock = 1;
            this.effective_date_min = res.migration_date || null;
          } else {
            this.enable_migration_date_lock = 0;
            this.effective_date_min = null;
          }
          this.migration_date = res.migration_date || null;
        })
        .catch(err => {
          console.error(err);
        });
    },
    hasArrDeclarationBeenUsed(id) {
      let formData = new FormData();
      formData.append('id', id);

      return axios
        .post(this.$api_url + '/pf/has-arr-declaration-been-used/', formData)
        .then(response => {
          this.disable_edit = response.data;
          return response.data;
        })
        .catch(() => {
          this.disable_edit = 0;
          return 0;
        });
    }

  },

  created() {
    this.getData();
  },

  computed: {
    effectiveDateRuleMin() {
      return this.effective_date_min || moment().format('YYYY-MM-DD');
    },
    filteredData() {
      let filtered_list = this.datalist;

      if (this.search) {
        filtered_list = filtered_list.filter(row =>
          Object.values(row).some(value =>
            value && String(value).toLowerCase().includes(this.search.toLowerCase())
          )
        );
        this.blankmsg = filtered_list.length === 0 ? 'Nothing found.' : '';
      }

      if (this.sortKey) {
        filtered_list = filtered_list.slice().sort((a, b) => {
          const index = this.getIndex(this.columns, 'name', this.sortKey);
          const order = this.sortOrders[this.sortKey];
          let aVal = a[this.sortKey];
          let bVal = b[this.sortKey];

          if (this.columns[index].type === 'date') {
            aVal = new Date(aVal).getTime();
            bVal = new Date(bVal).getTime();
            return (aVal === bVal ? 0 : aVal > bVal ? 1 : -1) * order;
          }
          if (this.columns[index].type === 'number') {
            return (+aVal === +bVal ? 0 : +aVal > +bVal ? 1 : -1) * order;
          }
          return String(aVal).localeCompare(String(bVal)) * order;
        });
      }

      return filtered_list;
    },

    paginatedData() {
      this.updatePagination();
      return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
    }
  }
}
</script>
